// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3tYZY","choiceBoxes":"toolbarselects_choiceBoxes__1k6Ol","simpleField":"toolbarselects_simpleField__37NwR"};